import React, { useState, useEffect } from 'react';

const LandingPage = () => {
    const [heroOpacity, setHeroOpacity] = useState(1);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setHeroOpacity(Math.max(0, 1 - scrollY / (window.innerHeight * 0.5)));
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="sticky top-0 h-screen w-full flex flex-col justify-center items-center">
            <div
                className="text-center space-y-5 px-6"
                style={{ opacity: heroOpacity, transition: 'opacity 0.05s linear' }}
            >
                <h1 className="text-6xl md:text-7xl font-bold tracking-tight text-white">
                    vibeu<span className="text-orange-400">.</span>tech
                    <span className="animate-blink text-orange-400">|</span>
                </h1>
                <p
                    className="text-base md:text-lg tracking-widest uppercase"
                    style={{ color: 'rgba(255,255,255,0.42)' }}
                >
                    Chandler &mdash; Developer &amp; IT Professional
                </p>
                <div className="pt-4">
                    <a href="#about" className="glass-btn">
                        View My Work
                    </a>
                </div>
            </div>

            <div
                className="absolute bottom-8 flex flex-col items-center gap-1 text-xs tracking-widest uppercase animate-bounce"
                style={{
                    opacity: heroOpacity * 0.45,
                    color: 'rgba(255,255,255,0.55)',
                    transition: 'opacity 0.05s linear',
                }}
            >
                <span>Scroll</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </div>
    );
};

export default LandingPage;
